module.exports = __webpack_public_path__ + "img/login_bg1.1dcd4624.png";